import { create } from "zustand";

type BreadcrumbItem = {
  path: string;
  label: string;
};

type BreadcrumbState = {
  breadcrumbs: BreadcrumbItem[];
  setBreadcrumbs: (breadcrumbs: BreadcrumbItem[]) => void;
  updateLastBreadcrumb: (label: string) => void;
  updateBreadcrumbByIndex: (index: number, label: string) => void;
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (isOpen: boolean) => void;
};

const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  breadcrumbs: [],
  setBreadcrumbs: (breadcrumbs) => set({ breadcrumbs }),
  updateLastBreadcrumb: (label) =>
    set((state) => {
      const updatedBreadcrumbs = [...state.breadcrumbs];
      updatedBreadcrumbs[updatedBreadcrumbs.length - 1] = {
        ...updatedBreadcrumbs[updatedBreadcrumbs.length - 1],
        label
      };
      return { breadcrumbs: updatedBreadcrumbs };
    }),
    updateBreadcrumbByIndex: (index, label) =>
    set((state) => {
      const updated = [...state.breadcrumbs];

      if (index >= 0 && index < updated.length) {
        updated[index] = {
          ...updated[index],
          label,
        };
      }

      return { breadcrumbs: updated };
    }),
  isSidebarOpen: true,
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  setSidebarOpen: (isOpen) => set({ isSidebarOpen: isOpen })
}));

export default useBreadcrumbStore;
